export default "__VITE_ASSET__4e0229fa__"